import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import { Text } from '../../../react-components/Text';

interface ChartCustomTooltipDataProps {
  label: string;
  value: number;
  color: string;
}

interface ChartCustomTooltipProps {
  label: string;
  data: Array<ChartCustomTooltipDataProps>;
  tooltipContainerStyle?: React.CSSProperties;
}

export const AnalyticsChartTooltip = ({ label, data, tooltipContainerStyle = {} }: ChartCustomTooltipProps) => {
  return (
    <div
      style={{
        backgroundColor: `#70707099`,
        padding: `16px`,
        borderRadius: `8px`,
        minWidth: `100px`,
        ...tooltipContainerStyle,
      }}
    >
      {data.map((entry) => (
        <Grid container direction="row" justifyContent="space-between" gap="8px">
          <Text variant="body" style={{ color: entry.color, fontWeight: `bold` }}>
            {entry.value}
          </Text>
          <Text
            variant="ultra-small"
            style={{ fontSize: `11px`, color: RoutalPalette.white, textTransform: `lowercase` }}
          >
            {entry.label}
          </Text>
        </Grid>
      ))}

      <VSpacer small />

      <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        <Text variant="ultra-small" style={{ color: RoutalPalette.white }}>
          {label}
        </Text>
      </Grid>
    </div>
  );
};
